import React from "react";

import ClientStrategyPage from "containers/admin/clients/client/components/client-strategy-page/client-strategy-page";

import { ClientStrategyCategoryDTOStrategyCategory } from "generated/schemas";

const BrandContentGuidelinesPage: React.FC = () => (
  <ClientStrategyPage
    strategyCategory={ClientStrategyCategoryDTOStrategyCategory.BRAND_GUIDELINES}
    formId="brand-content-guidelines-form"
    sidebarSectionId="brand-guidelines-nav"
    emptyMessage="Brand guidelines template is not available."
    saveSuccessTitle="Brand guidelines saved"
    saveErrorTitle="Could not save brand guidelines"
    editButtonLabel="Edit guidelines"
    header={{ title: "Brand guidelines" }}
    breadcrumb={{
      parents: [{ label: "Strategy", active: false }],
      label: "Brand guidelines",
      pathKey: "clientBrandGuidelinesPath",
      includeActiveTab: false,
    }}
  />
);

export default BrandContentGuidelinesPage;
